/**
 * menus/type_3.js
 * theme_type = 'type_3' (canon/캐논) 전용 GNB 구성.
 *
 * 현재는 type_1과 동일한 구성이지만, canon 전용 메뉴가 필요하면
 * 이 파일에서 SITEMAPS / MENUS 를 독립적으로 수정하세요.
 * base.js의 SECTIONS·GROUPS·ITEMS·TABS는 자유롭게 import해서 사용 가능합니다.
 *
 * 예시 (책자/캘린더 중심 교육 메뉴):
 *   export const MENUS = [
 *       { GROUP: GROUPS.DIGITAL_BOOKLETS,  SECTIONS: [...] },
 *       { GROUP: GROUPS.DIGITAL_CALENDARS, SECTIONS: [...] },
 *   ];
 */

export { SITEMAPS, MENUS } from './type_1.js';
